<template>
  <vx-card>
    <div>
      <div class="font-semibold text-grey select-none w-full text-left"> CONFIGURAÇÕES </div>
    </div>
    <hr style="margin-top: 0.25rem;"/>
    <div>
      <b-form-group
        id="version-selector"
        label="API:"
        label-for="api-version"
      >
        <b-form-select
          id="api-version"
          v-model="apiVersion"
          :options="[
            {
              value: 'v1',
              text: 'Versão 1'
            },
            {
              value: 'v2',
              text: 'Versão 2'
            }
          ]"
        />
      </b-form-group>
      <b-form-group
        label="Exceções"
        id="response-flags"
      >
        <div class="flex w-full flex-wrap gap-10">
          <b-form-checkbox
            v-model="flags.pe"
          >
            PHP
          </b-form-checkbox>
          <b-form-checkbox
            v-model="flags.tpe"
          >
            Terceiros (Biblioteca)
          </b-form-checkbox>
          <b-form-checkbox
            v-model="flags.ne"
          >
            Notificação
          </b-form-checkbox>
          <b-form-checkbox
            v-model="flags.ve"
          >
            Validação
          </b-form-checkbox>
          <b-form-checkbox
            v-model="flags.ge"
          >
            Primeiros (Exception)
          </b-form-checkbox>
        </div>
      </b-form-group>
      <b-form-group
        label="Feedback Frontend"
      >
        <b-form-checkbox
          v-model="useVsLoading"
        >
          Overlay de Carregamento
        </b-form-checkbox>
        <b-form-checkbox
          v-model="showResponse"
        >
          Mostrar Mensagem Sucesso
        </b-form-checkbox>
        <b-form-checkbox
          v-model="showError"
        >
          Mostrar Mensagem Erro
        </b-form-checkbox>
      </b-form-group>
      <b-form-group
        id="controller-return-group"
        label="Controller Retorna:"
        label-for="controller-return"
      >
        <b-form-select
          id="controller-return"
          v-model="controllerReturn"
          :options="[
            {
              value: 'jsonresource',
              text: 'Json Resource'
            },
            {
              value: 'array',
              text: 'Array'
            },
            {
              value: 'collection',
              text: 'Collection'
            },
            {
              value: 'object',
              text: 'Object'
            },
            {
              value: 'string',
              text: 'String'
            },
            {
              value: 'number',
              text: 'Number'
            }
          ]"
        />
      </b-form-group>
      <b-form-group
        label="Forçar Status de Retorno"
        label-for="status-force"
      >
        <b-form-input
          type="number"
          id="status-force"
          v-model="statusForced"
        />
      </b-form-group>
      
    </div>
    <div class="pt-2">
      <div>
        <div class="font-semibold text-grey select-none w-full text-left"> OPERAÇÕES </div>
      </div>
      <hr style="margin-top: 0.25rem;"/>
      <div class="flex justify-center gap-4">
        <b-button @click="testSearch" variant="primary"> Busca </b-button>
        <b-button @click="testNotFound" variant="danger"> 404 </b-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import V1Service from '@/services/api/V1Service'
import V2Service from '@/services/api/V2Service'

import {
  BFormSelect,
  BFormGroup,
  BFormCheckbox,
  BFormInput,
  BButton,
} from 'bootstrap-vue'

export default {
  components: {
    BFormSelect,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BButton,
  },
  data: () => ({
    apiVersion: 'v1',
    v1Service: null,
    v2Service: null,
    controllerReturn: 'array',
    flags: {
      pe: false,
      tpe: false,
      ne: false,
      ve: false,
      ge: false
    },
    statusForced: null,
    useVsLoading: true,
    showResponse: true,
    showError: true,
  }),
  methods: {
    testNotFound() {
      this.testRequest('notFound')
    },
    testSearch() {
      this.testRequest('search')
    },
    testRequest(method = 'search') {
      console.info("Iniciando requisição...")
      if (this.useVsLoading) this.$vs.loading()
      return this.service()[method]({...this.flags, forceStatus: this.statusForced, controllerReturn: this.controllerReturn}).then(
        response => {
          console.info("Obteve Resposta na requisição", response)
          if (this.showResponse) this.notifySuccess(this.$vs, "Operação realizada com sucesso!")
        },
        error => {
          console.info("Obteve Erro na requisição")
          console.error(error)
          if (this.showError) this.notifyError(this.$vs, "Não foi possível executar esta operação")
        }
      ).finally(
        () => {
          console.info("Fechando requisição...")
          if (this.useVsLoading) this.$vs.loading.close()
        }
      )
    },
    service() {
      switch (this.apiVersion) {
      case 'v2':
        return this.v2Service
      default:
        return this.v1Service
      }
    },
    loadServices() {
      this.v1Service = V1Service.build(this.$vs)
      this.v2Service = V2Service.build(this.$vs)
    }
  },
  beforeMount() {
    this.loadServices()
  }
}
</script>

<style>

</style>